<template>
  <div class="percentage-container">
    <span :class="teamColorClass" class="percentage">{{ teamForm }}%</span>
      <span>{{ $t("form_rating") }}</span>
      <div class="a-vs-c--rating">
        <div
          v-for="index in 20" :key="index"
          :class="getClassItem(index)"></div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    teamForm: {
      type: Number,
      required: true
    },
    teamColorClass: {
      type: String,
      require: true
    },
    teamClass: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getClassItem (index) {
      if (this.teamClass[0][index]) {
        return this.teamColorClass
      }
      return ''
    }
  }
}
</script>
<style scoped>
.percentage-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
div.a-vs-f-success-secondary {
   background: #1FC276 !important;
}
div.a-vs-f-danger-secondary {
   background: #ff5959 !important;
}
</style>
